// Dev-only helpers behind devconfig's link buttons: log a test account in and
// build an admin link that AuthGate accepts (?type=moderator&session_id=…&token=…).
//
// Credentials are never hardcoded: they come from .env / .env.uat / .env.prod
// (gitignored) and can be edited on the page.
import { CLIRNET_API } from "../api/endpoints.js";

const env = import.meta.env;

export const LINK_KINDS = {
  // Moderator (admin panel): the link carries the access_token.
  moderator: {
    key: "moderator",
    title: "Moderator",
    loginUrl: `${CLIRNET_API.BASE_URL}/login`,
    linkType: "moderator",
    tokenField: "access_token",
    fields: ["email", "password"],
    defaults: {
      email: env.MODERATORLINK_EMAIL || "",
      password: env.MODERATORLINK_PASSWORD || "",
    },
    body: ({ email, password }) => ({ email, password }),
  },
};

// POST the kind's login API and return only the token that goes into the link.
export async function fetchLinkToken(kind, creds, fetchImpl = fetch) {
  const res = await fetchImpl(kind.loginUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(kind.body(creds)),
  });
  let body = null;
  try {
    body = await res.json();
  } catch {
    // non-JSON error page - reported below via the status code
  }
  if (!res.ok) {
    throw new Error(body?.message || body?.error || `Login failed (HTTP ${res.status})`);
  }
  const token = body?.[kind.tokenField];
  if (typeof token !== "string" || !token) {
    throw new Error(`Login response had no ${kind.tokenField}`);
  }
  return token;
}

// Where a generated link points. Dev = this running app (e.g. http://localhost:8081);
// Prod = the deployed admin app (overridable via DEVLINK_PROD_ORIGIN).
export const PROD_ORIGIN = (env.DEVLINK_PROD_ORIGIN || "https://clir-rj-session-mfe.pages.dev").replace(/\/+$/, "");

export const LINK_TARGETS = [
  { key: "dev", label: "Dev link", origin: () => window.location.origin },
  { key: "prod", label: "Prod link", origin: () => PROD_ORIGIN },
];

export function buildLink({ origin = window.location.origin, type, sessionId, token }) {
  const params = new URLSearchParams({ type, session_id: String(sessionId), token });
  return `${origin}/?${params.toString()}`;
}
